const useDisplayValue = (type) => {
  const formattingFn = (data) => {
    if (data > 1000000000) return `${(data / 1000000000).toFixed(0)}B`
    else if (data > 1000000) return `${(data / 1000000).toFixed(0)}M`
    else if (data > 1000) return `${(data / 1000).toFixed(0)}K`
    else if (data < 1000 && type !== "percent") return `${data.toFixed(0)}`
    else if (data < 100 && type !== "percent") return `${data.toFixed(0)}%`
    else if (data < 100 && type === "percent") return `${data.toFixed(0)}%`
/*     else if (data < 100 && type === "percent") return `${data.toFixed(2)}%`
    else if (data < 10) return data.toFixed(2) */
  }

  return {
    formattingFn
  }
}

export default useDisplayValue
